import { cacheExchange, createClient, fetchExchange } from "@urql/core"
import { registerUrql } from "@urql/next/rsc"
import { graphql } from "../graphql"
import type { ErrorHandler } from "../types"
import { apqExchange } from "./exchange/apq-exchange"
import { errorExchange } from "./exchange/errorExchange"
import { GRAPHQL_API_URL, GRAPHQL_HEADERS } from "./shared"

const makeClient = (errorHandler: ErrorHandler) => {
  return () =>
    createClient({
      suspense: true,
      url: GRAPHQL_API_URL,
      preferGetMethod: false,
      exchanges: [
        errorExchange(errorHandler),
        cacheExchange,
        apqExchange,
        fetchExchange,
      ],
      fetchOptions: {
        headers: GRAPHQL_HEADERS,
      },
    })
}

export const makeGetClient = (errorHandler: ErrorHandler) => {
  return registerUrql(makeClient(errorHandler))
}

export { graphql, createClient, fetchExchange, GRAPHQL_HEADERS }
